"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalleryView = void 0;
const engine_1 = require("../../engine");
const i18n_1 = require("../../exports/i18n");
const store_1 = require("../../exports/store");
const selectors_1 = require("../../exports/store/selectors");
const types_1 = require("../../types");
const datasheet_1 = require("../datasheet");
const card_view_1 = require("./card_view");
const config_1 = require("../../config");
const utils_1 = require("../../utils");
class GalleryView extends card_view_1.CardView {
    static defaultStyle(snapshot, srcView) {
        // the first attachment field set as default cover field
        const initCoverField = srcView.columns.find(col => snapshot.meta.fieldMap[col.fieldId].type === types_1.FieldType.Attachment);
        return {
            layoutType: store_1.LayoutType.Flex,
            isAutoLayout: false,
            cardCount: 4,
            isCoverFit: true,
            coverFieldId: initCoverField ? initCoverField.fieldId : undefined,
            isColNameVisible: true,
        };
    }
    static defaultRows(srcView) {
        if (srcView) {
            return srcView.rows;
        }
        return [];
    }
    static generateDefaultProperty(snapshot, activeViewId) {
        const views = snapshot.meta.views;
        let srcView;
        if (activeViewId) {
            srcView = (0, selectors_1.getViewById)(snapshot, activeViewId);
        }
        if (!srcView) {
            srcView = views[0];
        }
        return {
            id: datasheet_1.DatasheetActions.getNewViewId(views),
            name: datasheet_1.DatasheetActions.getDefaultViewName(views, store_1.ViewType.Gallery),
            type: store_1.ViewType.Gallery,
            columns: this.defaultColumns(srcView, 4),
            rows: this.defaultRows(srcView),
            style: this.defaultStyle(snapshot, srcView),
            displayHiddenColumnWithinMirror: true
        };
    }
    static getViewIntroduce() {
        return {
            title: (0, i18n_1.t)(i18n_1.Strings.gallery_view),
            desc: (0, i18n_1.t)(i18n_1.Strings.gallery_guide_desc),
            videoGuide: (0, utils_1.integrateCdnHost)(config_1.Settings.view_gallery_guide_video.value),
        };
    }
}
exports.GalleryView = GalleryView;
/**
 * gallery view UI setting
 */
GalleryView.setGalleryStyle2Action = (snapshot, payload) => {
    const { viewId, styleKey, styleValue } = payload;
    const viewIndex = (0, selectors_1.getViewIndex)(snapshot, viewId);
    if (viewIndex < 0) {
        return null;
    }
    const view = snapshot.meta.views[viewIndex];
    if (view.type !== store_1.ViewType.Gallery || styleValue === view.style[styleKey]) {
        return null;
    }
    return {
        n: engine_1.OTActionName.ObjectReplace,
        p: ['meta', 'views', viewIndex, 'style', styleKey],
        oi: styleValue,
        od: view.style[styleKey],
    };
};
//# sourceMappingURL=gallery_view.js.map